// TODO: нужен ли этот файл?
// мне кажется нет, искоренить

/**
 * Fetch data with retry
 * @param url
 * @param config
 * @param attempts
 */

export const fetchWithRetry = async <Data>(
  url: string,
  config: RequestInit,
  attempts = 3,
): Promise<Data> => {
  try {
    const response = await fetch(url, {
      ...config,
      headers: {
        ...config.headers,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const data = await response.json();
      throw {...data, status: response.status};
    }

    const data = (await response.json()) as Data;

    return data as Data;
  } catch (error) {
    if (attempts > 1) {
      return fetchWithRetry(url, config, attempts - 1);
    }

    throw error;
  }
};
